export const SearchaniseTagSeparator = '[:ATTR:]';

type TagMapping = {
  facetId: string;
  filter: string;
};

export type CollectionTileEmbeds = {
  image: string;
  position: string;
  link?: string;
}[];

export const SizeFacetId = 'snize_facet1';
export const PetyFriendlyFacetId = 'snize_facet6';
export const CareLevelFacetId = 'snize_facet5';
export const LightLevelFacetId = 'snize_facet3';
export const WaterNeedsFacetId = 'snize_facet2';
export const HumidityLevelsFacetId = 'snize_facet4';
export const CategoryFacetId = 'snize_facet7';
export const ZoneFacetId = 'snize_facet8';

const SizeTagMapping = {
  'small-size': { facetId: SizeFacetId, filter: 'Small' },
  'medium-size': { facetId: SizeFacetId, filter: 'Medium' },
  'large-size': { facetId: SizeFacetId, filter: 'Large' },
  'xlarge-size': { facetId: SizeFacetId, filter: 'Extra Large' },
  '1gal-size': { facetId: SizeFacetId, filter: '1 Gallon' },
  '5gal-size': { facetId: SizeFacetId, filter: '5 Gallon' },
};

const PetFriendlyMapping = {
  'pet-safe': { facetId: PetyFriendlyFacetId, filter: 'Pet Safe' },
  'pet-warning': { facetId: PetyFriendlyFacetId, filter: 'Not a Chew Toy' },
  'pet-hazard': { facetId: PetyFriendlyFacetId, filter: 'Keep Away From Pets' },
};

const CareLevelMapping = {
  'im-easy': { facetId: CareLevelFacetId, filter: 'I\'m Easy' },
  'plays-hard-to-get': { facetId: CareLevelFacetId, filter: 'Plays Hard to Get' },
  'high-maintenance': { facetId: CareLevelFacetId, filter: 'High Maintenance' },
};

const LightLevelMapping = {
  'low-light': { facetId: LightLevelFacetId, filter: 'Low' },
  'medium-light': { facetId: LightLevelFacetId, filter: 'Medium' },
  'high-light': { facetId: LightLevelFacetId, filter: 'High' },
};

const WaterNeedsMapping = {
  'low-water': { facetId: WaterNeedsFacetId, filter: 'Low' },
  'medium-water': { facetId: WaterNeedsFacetId, filter: 'Medium' },
  'high-water': { facetId: WaterNeedsFacetId, filter: 'High' },
};

const HumidityLevelsMapping = {
  'low-humidity': { facetId: HumidityLevelsFacetId, filter: 'Low' },
  'medium-humidity': { facetId: HumidityLevelsFacetId, filter: 'Medium' },
  'high-humidity': { facetId: HumidityLevelsFacetId, filter: 'High' },
};

const HardinessZoneMapping = {
  'zone-3': { facetId: ZoneFacetId, filter: 'Zone 3' },
  'zone-4': { facetId: ZoneFacetId, filter: 'Zone 4' },
  'zone-5': { facetId: ZoneFacetId, filter: 'Zone 5' },
  'zone-6': { facetId: ZoneFacetId, filter: 'Zone 6' },
  'zone-7': { facetId: ZoneFacetId, filter: 'Zone 7' },
  'zone-8': { facetId: ZoneFacetId, filter: 'Zone 8' },
  'zone-9': { facetId: ZoneFacetId, filter: 'Zone 9' },
  'zone-10': { facetId: ZoneFacetId, filter: 'Zone 10' },
  'zone-11': { facetId: ZoneFacetId, filter: 'Zone 11' },
  'zone-12': { facetId: ZoneFacetId, filter: 'Zone 12' },
  'zone-13': { facetId: ZoneFacetId, filter: 'Zone 13' },
};

export const TagToSearchaniseFilterMapping: Record<string, TagMapping> = {
  ...SizeTagMapping,
  ...PetFriendlyMapping,
  ...CareLevelMapping,
  ...LightLevelMapping,
  ...WaterNeedsMapping,
  ...HumidityLevelsMapping,
  ...HardinessZoneMapping,
};

export const SearchaniseSortSelectors = {
  SORT_BY_RELEVANCE_DESC: '.snize-main-panel-dropdown-relevance-desc',
  SORT_BY_DISCOUNT_DESC: '.snize-main-panel-dropdown-discount-desc',
  SORT_BY_REVIEWS_ASC: '.snize-main-panel-dropdown-total_reviews-asc',
  SORT_BY_REVIEWS_DESC: '.snize-main-panel-dropdown-total_reviews-desc',
  SORT_BY_CREATED_DATE_ASC: '.snize-main-panel-dropdown-created-asc',
  SORT_BY_CREATED_DATE_DESC: '.snize-main-panel-dropdown-created-desc',
  SORT_BY_RATING_ASC: '.snize-main-panel-dropdown-reviews_average_score-asc',
  SORT_BY_RATING_DESC: '.snize-main-panel-dropdown-reviews_average_score-desc',
};

export const SelectedSearchOptionTitleMapping = {
  Relevance: 'Most Relevant',
  'Discount: High to Low': 'Maximum Discount',
  'Total reviews: High to Low': 'Most Reviewed',
  'Rating: High to Low': 'Highest Rated',
};

export const DisplayBestSellerThreshold = 6;
